<template lang="pug">
	div.pr-4.h-24(:class="{ hasAction: notification.actions}")
		.notification.flex.p-4.pr-6.rounded-lg.text-white.bg-gray-9.rounded-lg.shadow-2xl(:class="notification.type")
			.flex-shrink-0(:class="{ spin: notification.icon == 'loader-outline'}")
				eva-icon.icon.text-blue-6.mr-4(width="32" height="32" v-if="notification.icon" :name="notification.icon" :class="notification.type")
			.flex-1(:class="{ alignCenter: !notification.message && !notification.action }")
				h3.-mt-1 {{ notification.title }}
				p.text-white.opacity-75 {{ notification.message }}

				.flex
					button.small.text-white.mt-2(v-for="action in notification.actions" @click="runAction(action)") {{ action.text }}
</template>

<script>
import { ref } from "@vue/composition-api";
import { mapActions } from "vuex";

export default {
  name: "Notification",
  props: ["notification"],
  setup(props, { root }) {
    const timeOut = ref(undefined);

    // set timout if any
    if (!props.notification.timeOut) {
      timeOut.value = setTimeout(() => {
        root.$store.dispatch("removeNotification", props.notification.id);
      }, 4000);
    } else if (props.notification.timeOut === "infinite") return;
    else {
      timeOut.value = setTimeout(() => {
        root.$store.dispatch("removeNotification", props.notification.id);
      }, props.notification.timeOut);
    }

    // set icon if not specified
    if (!props.notification.icon) {
      switch (props.notification.type) {
        case "error":
        case "error-important":
          props.notification.icon = "alert-circle";
          break;
        case "success":
        case "success-important":
          props.notification.icon = "checkmark-circle-2";
          break;
        case "warning":
        case "warning-important":
          props.notification.icon = "alert-triangle";
          break;
        default:
          props.notification.icon = "info";
      }
    }
    // run actions if any
    function runAction(action) {
      // access global utility action
      root.$store.dispatch("runAction", action);
      root.$store.dispatch("removeNotification", props.notification.id);
      clearTimeout(timeOut.value);
    }
    return { timeOut, runAction };
  }
};
</script>

<style lang="sass" scoped>
.notification.success-important
	@apply bg-green-6
.notification.error-important
	@apply bg-red-6
.notification.warning-important
	@apply bg-orange-6
.icon.success
	@apply text-green-4
.icon.error
	@apply text-red-4
.icon.warning
	@apply text-orange-4
.icon.success-important, .icon.error-important, .icon.warning-important
	@apply text-white

button.small
	background: rgba(255,255,255,0.1)
	&:hover
		background:rgba(255,255,255,0.2)
.hasAction
	height: 9rem

.alignCenter
	@apply self-center
</style>
